import { sendUserProfile } from "../handlers";

export function saveSelectedData (field, value, campaign_id, userToken) {
  const userProfileData = {};
  userProfileData[field] = value;
  userProfileData['campaign_id'] = campaign_id;
  userProfileData['authenticity_token'] = userToken;
  sendUserProfile(userProfileData)
}
